export default {
      id: "pushpay-logo-header-mobile-usage",
      viewBox: "0 0 90 34",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#pushpay-logo-header-mobile",
      toString: function () {
        return this.url;
      }
    }